import { render, staticRenderFns } from "./SellerDataComponent.vue?vue&type=template&id=4e1a4372&scoped=true&"
import script from "./SellerDataComponent.vue?vue&type=script&lang=js&"
export * from "./SellerDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./SellerDataComponent.vue?vue&type=style&index=0&id=4e1a4372&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a4372",
  null
  
)

export default component.exports